const AUTH_PAGES = {
  AUTH_HEADER_START_FREE: 'Start Free',
  AUTH_HEADER_ENTER_ACCOUNT: 'Enter Your Account',
  AUTH_FOOTER_TRUST: 'Trusted by over 40,000 online businesses.',

  LOGIN_HEADER_TITLE: 'Enter Raychat',
  LOGIN_HEADER_SUB_TITLE: "Don't have an account?",
  LOGIN_HEADER_SIGNUP_TEXT: 'Sign up now!',
  LOGIN_ONE_TIME_VERIFICATION: 'Login with One-Time Verification Code!',
  LOGIN_ONE_TIME_VERIFICATION_CLICK: 'Click here',
  LOGIN_FORGOTTEN_PASSWORD: 'Forgot your password?',
  LOGIN_FORGOTTEN_PASSWORD_CLICK: 'Click',
  LOGIN_ENTER_WEBAPP_LINK: 'Enter online chat',
  LOGIN_FORM_SUBMIT: 'Enter Raychat',

  SIGNUP_HEADER_TITLE: 'Signup',
  SIGNUP_ALREADY_ACCOUNT: 'Already have an account?',
  SIGNUP_LOGIN_LINK: 'Enter',
  SIGNUP_SUBMIT_BTN: 'Signup',
  NAME_PLACEHOLDER: 'Name',
  LAST_NAME_PLACEHOLDER: 'Last Name',
  EMAIL_PLACEHOLDER: 'Email',
  MOBILE_PLACEHOLDER: 'Mobile - +989*********',
  PASSWORD_PLACEHOLDER: 'Password',

  ONE_TIME_FORM_SUBMIT: 'Send',
  ONE_TIME_RETURN: 'Return',
  ONE_TIME_OPTION_ONE: 'Email',
  TWO_STEP_OPTION_TWO: 'Phone Number',
  DISABLE_TOOLTIP: 'Filling in the selected field is mandatory!',
  INVALID_EMAIL_TOOLTIP: 'The entered email is not valid!',
  INVALID_PHONE_TOOLTIP: 'The entered phone number is not valid!',
  ONE_TIME_IMPORT_CODE_PLACEHOLDER: 'Enter the code...',
  ONE_TIME_IMPORT_CODE_TOOLTIP: 'The entered code must be 4 digits!',

  LANDING_CARD: {
    TITLE: 'Install widget',
    SUBTITLE: '',
    COPY_BTN: 'Copy script',
    FOOTER:
      'If you use content management systems (CMS) like Wordpress, instead of copying above code you can get related plugin after entering dashboard',
    SUBMIT_BTN: 'Enter dashboard',
  },

  PAGE_TITLE: 'Login With One Time Verification Code!',
  FORM_DESC: `First, select one of the options below, then enter the email address or phone number you used during registration. The otp will be sent to you.`,
  IMPORT_CODE_DESC: 'Enter the code sent to your email or phone number.',
  WITH_COUNTRY_MOBILE_PLACEHOLDER: 'Mobile',

  SITE_REGISTERED_BEFORE:
    'This site has already been registered. Please enter another website address',
  SITE_UN_VALID: 'Please enter a valid website address!',
  SITE_FIELDS_EMPTY: 'Please enter the website address',
  UN_VALID_EMAIL: 'Email is invalid',
};

export default AUTH_PAGES;
